import { AxiosResponse } from 'axios';

import {
  AddMunicipalityBlackListProps,
  MunicipalityBlackListDto,
  PaginatedNameFilterOptions,
  PaginatedList,
  ServiceResult,
} from '@project/types';
import { authNetworkService } from '@project/services';

import municipalityBlackListUrls from './municipality-black-list.urls';

const getMunicipalityBlackList = async (
  filter: PaginatedNameFilterOptions,
): Promise<PaginatedList<MunicipalityBlackListDto>> => {
  const url = municipalityBlackListUrls.getPaginatedBlackListUrl(filter);

  return authNetworkService
    .get(url)
    .then(
      (apiResponse: AxiosResponse<ServiceResult<PaginatedList<MunicipalityBlackListDto>>>) =>
        apiResponse.data.data,
    );
};

const addMunicipalityBlackList = async (formData: AddMunicipalityBlackListProps) => {
  const url = municipalityBlackListUrls.getBaseUrl();

  return authNetworkService.post(url, formData);
};

const removeMunicipalityBlackList = async (municipalityBlackListId: string) => {
  const url = municipalityBlackListUrls.deleteUrl(municipalityBlackListId);

  return authNetworkService.delete(url);
};

export default {
  getMunicipalityBlackList,
  addMunicipalityBlackList,
  removeMunicipalityBlackList,
};
